import { render, staticRenderFns } from "./ProfileCompetencies.vue?vue&type=template&id=d709c3d2&scoped=true"
import script from "./ProfileCompetencies.vue?vue&type=script&lang=js"
export * from "./ProfileCompetencies.vue?vue&type=script&lang=js"
import style0 from "./ProfileCompetencies.vue?vue&type=style&index=0&id=d709c3d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d709c3d2",
  null
  
)

export default component.exports